var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlinedStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8019_204620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1802 8.59909C14.8475 8.02 14.4909 6.92346 13.6107 6.84756L11.4853 6.66429C11.1164 6.63248 10.7954 6.3995 10.6507 6.05871L9.82215 4.10675C9.47722 3.29415 8.32541 3.29447 7.98093 4.10725L7.15141 6.06444C7.00667 6.40594 6.68481 6.63928 6.31523 6.67063L4.19903 6.85017C3.31761 6.92495 2.9602 8.02321 3.6288 8.60242L5.2379 9.99638C5.51846 10.2394 5.64131 10.6179 5.55697 10.9794L5.07409 13.0493C4.87313 13.9107 5.80736 14.5897 6.56468 14.1326L8.38422 13.0344C8.70201 12.8426 9.09989 12.8426 9.41769 13.0344L11.241 14.1349C11.9978 14.5917 12.9316 13.914 12.7319 13.0529L12.2508 10.9781C12.1672 10.6173 12.2898 10.2398 12.5695 9.99697L14.1802 8.59909ZM9.418 11.7144C9.10007 11.5221 8.70174 11.5219 8.38366 11.714L8.27521 11.7794C7.51776 12.2367 6.5833 11.5574 6.7846 10.6958L6.81414 10.5694C6.89856 10.2081 6.77595 9.8297 6.49564 9.58654L6.39026 9.49513C5.72298 8.91628 6.07905 7.81983 6.95911 7.74348L7.09952 7.7313C7.46897 7.69924 7.79034 7.46538 7.93447 7.12371L7.98113 7.01309C8.32475 6.19852 9.47881 6.19782 9.82341 7.01197L9.87414 7.13182C10.0185 7.47292 10.3396 7.70627 10.7086 7.73829L10.8499 7.75054C11.7299 7.82689 12.086 8.92334 11.4187 9.50219L11.3133 9.5936C11.033 9.83676 10.9104 10.2152 10.9948 10.5765L11.0238 10.7004C11.2252 11.5624 10.2899 12.2417 9.53251 11.7836L9.418 11.7144Z",
    fill: "#B08C3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8019_204620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9525,
    height: 16.9525,
    fill: "white",
    transform: "translate(0.424805 0.523438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedStar);
export default __webpack_public_path__ + "static/media/outlined-star.5f17983b919d8412210f196f1972e17e.svg";
export { ForwardRef as ReactComponent };